import { SectionSpecifier } from './use-sectioned-input'

const alphanumeric = /[^A-Za-z0-9]+/g

export function alphabeticSection({
  options,
  placeholder,
  suffix,
  prefix,
  tick
}: {
  options: string[]
  placeholder: string
  suffix?: string
  prefix?: string
  tick?: SectionSpecifier['tick']
}): SectionSpecifier {
  if (suffix?.replace(alphanumeric, '')) {
    throw new Error(`Suffix must be non-alphanumeric: ${suffix}`)
  }
  if (prefix?.replace(alphanumeric, '')) {
    throw new Error(`Suffix must be non-alphanumeric: ${prefix}`)
  }

  return {
    type: 'alphabetic',
    prefix,
    suffix,
    placeholder,
    tick: tick || ((s) => s.value),
    update(state, action) {
      if (!action.value) {
        return {
          value: placeholder,
          referenceValue: ''
        }
      } else {
        const matches = options.filter((o) => o.startsWith(`${state.referenceValue}${action.value}`))
        if (matches.length) {
          const exclusiveMatch = matches.length === 1
          return {
            value: matches[0],
            referenceValue: exclusiveMatch ? '' : matches[0],
            goToNextSection: exclusiveMatch
          }
        } else {
          const valMatch = options.filter((o) => o.startsWith(`${action.value}`))
          const exclusiveMatch = valMatch.length === 1
          if (valMatch.length) {
            return {
              value: valMatch[0],
              referenceValue: exclusiveMatch ? '' : valMatch[0],
              goToNextSection: exclusiveMatch
            }
          } else {
            return { value: state.value, referenceValue: '' }
          }
        }
      }
    },
    increment(state) {
      const index = options.indexOf(state.value)
      if (index >= 0 && index < options.length - 1) {
        return options[index + 1]
      } else {
        return options[0]
      }
    },
    decrement(state) {
      const index = options.indexOf(state.value)
      if (index >= 1) {
        return options[index - 1]
      } else {
        return options[options.length - 1]
      }
    }
  }
}
